<div [ngSwitch]="icon">
 <!-- Brazil Flag -->
  <img *ngSwitchCase="'+55'" style="height: 16px;" src="../../../../assets/svgs/flag_br_ico.svg" alt="{{icon}}">
  <!-- USA Flag -->
  <img *ngSwitchCase="'+1'" style="height: 16px;" src="../../../../assets/svgs/usa_flag_ico.svg" alt="{{icon}}">
   <!-- Portugal Flag -->
  <img *ngSwitchCase="'+351'" style="height: 16px;" src="../../../../assets/svgs/portugal_flag_ico.svg" alt="{{icon}}">



</div>